var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrolf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1817 0H11.1804C5.44047 0 0.787354 4.65312 0.787354 10.393V10.3944C0.787354 16.1343 5.44047 20.7874 11.1804 20.7874H11.1817C16.9216 20.7874 21.5748 16.1343 21.5748 10.3944V10.393C21.5748 4.65312 16.9216 0 11.1817 0Z",
    fill: "#745171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.75852 14V5.27273H9.60369V9.12074H9.71875L12.8594 5.27273H15.071L11.8324 9.1804L15.1094 14H12.902L10.5114 10.4119L9.60369 11.5199V14H7.75852Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7874,
    height: 20.7874,
    fill: "white",
    transform: "translate(0.787354)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrolf);
export default __webpack_public_path__ + "static/media/KROLF.e26bc5407289c3c2ad3bb659bf8c2517.svg";
export { ForwardRef as ReactComponent };